"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoudspeakerClient = void 0;

var _baseclient = require("./baseclient");

var _definitions = require("../components/model/definitions");

const LOUDSPEAKER_BASE_URL_PRODUCTION = 'https://api.loudspeaker.cimpress.io';
const LOUDSPEAKER_BASE_URL_STAGING = 'https://int-api.loudspeaker.cimpress.io';

class LoudspeakerClient extends _baseclient.BaseClient {
  constructor(settings, env) {
    super(settings);
    this.baseUrl = env === _definitions.ServiceEnvironment.Production ? LOUDSPEAKER_BASE_URL_PRODUCTION : LOUDSPEAKER_BASE_URL_STAGING;
  }

  async getAnnouncements(queryParameters) {
    const announcementList = [];

    if (this.channelIds.length > 4) {
      console.warn('Loudspeaker: react-Loudspeaker supports viewing announcements from a maximum of 4 channels.' + ' Please lower the number of channels you are querying to 4 or below.');
      return announcementList;
    } // eslint-disable-next-line no-restricted-syntax


    for (const channelId of this.channelIds) {
      let announcementUrl = `${this.baseUrl}/v2/channels/${channelId}/announcements`;
      const channelUrl = `${this.baseUrl}/v1/channels/${channelId}`;

      if (queryParameters) {
        var _queryParameters$afte;

        announcementUrl = `${announcementUrl}?after=${encodeURIComponent((_queryParameters$afte = queryParameters.after[channelId]) !== null && _queryParameters$afte !== void 0 ? _queryParameters$afte : '2001-01-01T01:01:01Z')}`;
      }

      try {
        const responses = await Promise.all([fetch(announcementUrl, {
          method: 'GET',
          headers: this.headers
        }), fetch(channelUrl, {
          method: 'GET',
          headers: this.headers
        })]);

        if (!responses[0].ok || !responses[1].ok) {
          throw new Error(`Loudspeaker: Unable to retrieve announcements from ${channelId}`);
        }

        const results = await Promise.all([responses[0].json(), responses[1].json()]);
        results[0].forEach(a => announcementList.push(a));
      } catch (error) {
        console.warn(error.message);
      }
    }

    return announcementList;
  }

}

exports.LoudspeakerClient = LoudspeakerClient;